import { Link } from "react-router-dom";
import type { StaffHome, StaffShiftSummary } from "../../../api/staffApi";
import { formatShiftRange } from "../staffFormat";

type ActiveShiftCardProps = {
  home: StaffHome;
  enriched?: StaffShiftSummary | null;
};

const stateLabels: Record<string, string> = {
  not_scheduled: "Not on shift",
  scheduled: "Scheduled",
  available: "Available",
  working: "On the clock",
  on_break: "On break",
  clocked_out: "Clocked out",
};

export function ActiveShiftCard({ home, enriched }: ActiveShiftCardProps) {
  const shift = home.currentShift;
  const stateLabel = stateLabels[home.operationalState] ?? home.operationalState;

  if (!shift) {
    return (
      <section className="staff-active-card staff-active-card--idle">
        <p className="staff-active-card__eyebrow">Now</p>
        <h2 className="staff-active-card__title">{stateLabel}</h2>
        {home.nextShift ? (
          <p className="muted">
            Next shift{" "}
            <Link to={`/staff/shifts/${home.nextShift.id}`} className="staff-inline-link">
              {formatShiftRange(home.nextShift.scheduledStart, home.nextShift.scheduledEnd)}
            </Link>
          </p>
        ) : (
          <p className="muted">No upcoming shifts on your schedule.</p>
        )}
      </section>
    );
  }

  return (
    <Link to={`/staff/shifts/${shift.id}`} className="staff-active-card staff-active-card--link">
      <p className="staff-active-card__eyebrow">{stateLabel}</p>
      <h2 className="staff-active-card__title">{enriched?.roleName ?? "Current shift"}</h2>
      <p className="staff-active-card__event">{enriched?.eventName ?? "View shift"}</p>
      <p className="staff-active-card__time">{formatShiftRange(shift.scheduledStart, shift.scheduledEnd)}</p>
      <span className="staff-active-card__cta">Open shift →</span>
    </Link>
  );
}
